"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcPaymentInvoices = exports.UcPaymentHeader = exports.FieldsetPaymentGeneral = void 0;
const FieldsetPaymentGeneral_yaml_component_1 = __importDefault(require("./FieldsetPaymentGeneral.yaml?component"));
exports.FieldsetPaymentGeneral = FieldsetPaymentGeneral_yaml_component_1.default;
const UcPaymentHeader_yaml_component_1 = __importDefault(require("./UcPaymentHeader.yaml?component"));
exports.UcPaymentHeader = UcPaymentHeader_yaml_component_1.default;
const UcPaymentInvoices_yaml_component_1 = __importDefault(require("./UcPaymentInvoices.yaml?component"));
exports.UcPaymentInvoices = UcPaymentInvoices_yaml_component_1.default;
